import React, { useContext } from "react";
import IsVisSPCContext from "../CRUD/isVisContext";
import { ModoTemaContext } from "../../styles/theme/modoTema";
import logoConciliador from "../../styles/images/concilia-solucoes/conciliador/logo-conciliador.png";
import logoConciliadorBranca from "../../styles/images/concilia-solucoes/conciliador/logo-conciliador-branca-nova.png";
import logoVis from "../../styles/images/concilia-solucoes/conciliador/conciliador_vis.png";

const LogoConcilia: React.FC<{ classe: string; right?: boolean; branca?: boolean }> = ({ classe, right = false, branca = false }) => {
  const isVis = useContext(IsVisSPCContext);
  const ehVis = isVis?.isVisSPC === "vis";
  const { modo } = useContext(ModoTemaContext);
  const logoPadrao = branca || modo === "dark" ? logoConciliadorBranca : logoConciliador;
  return (
    <img
      className={classe}
      src={ehVis ? logoVis : logoPadrao}
      title={`${process.env.REACT_APP_VERSION}`}
      alt="Logo"
      style={right ? { float: "right", marginRight: 15 } : undefined}
    />
  );
};

export default LogoConcilia;
